import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56062db6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 刷新重试 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 去看看 ")

import {withDefaults} from 'vue';
import {Empty, Button} from 'vant';
import ErrorImg from '@/assets/img/error.png';
import NoneImg from '@/assets/img/null2.png';


// 注意: CustomEmpty 组件外包裹的组件一定要有高度才能自动居中
const __default__ = {
  name: 'CustomEmpty'
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    description: { default: '哎呀！页面加载发生意外' },
    type: null,
    onClickBtn: null,
    hideImg: { type: Boolean },
    img: { default: NoneImg }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.type === 'error')
    ? (_openBlock(), _createBlock(_unref(Empty), {
        key: 0,
        image: __props.hideImg ? '' : _unref(ErrorImg),
        description: __props.description,
        class: "empty-box"
      }, {
        default: _withCtx(() => [
          (__props.onClickBtn)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                plain: "",
                round: "",
                type: "primary",
                class: "btn",
                onClick: __props.onClickBtn
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["image", "description"]))
    : (_openBlock(), _createBlock(_unref(Empty), {
        key: 1,
        image: __props.hideImg ? '' : __props.img,
        description: __props.description,
        class: "empty-box"
      }, {
        default: _withCtx(() => [
          (__props.onClickBtn)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                plain: "",
                round: "",
                type: "primary",
                class: "btn",
                onClick: __props.onClickBtn
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["image", "description"]))
}
}

})